/**
 * Web Style Import
 *
 */

import './style/dnb-flex.scss'
